import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'relativeDate',
  standalone: true,
})
export class RelativeDatePipe implements PipeTransform {
  transform(value: string | Date | null | undefined): string {
    if (!value) return 'No hay postulaciones';

    const date = new Date(value);
    if (isNaN(date.getTime())) return 'Fecha inválida';

    const today = new Date();
    const diffTime = today.getTime() - date.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return 'Hoy';
    if (diffDays === 1) return 'Ayer';
    if (diffDays === 2) return 'Anteayer';
    if (diffDays < 7) return `Hace ${diffDays} días`;
    if (diffDays === 7) return 'Hace una semana';
    if (diffDays < 14) return 'Hace dos semanas';
    if (diffDays < 21) return 'Hace tres semanas';
    if (diffDays < 30) return 'Hace un mes';
    if (diffDays < 60) return 'Hace dos meses';
    if (diffDays < 365) return `Hace ${Math.floor(diffDays / 30)} meses`;

    const years = Math.floor(diffDays / 365);
    return `Hace ${years} año${years > 1 ? 's' : ''}`;
  }
}
